





























import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'

import { Breadcrumb } from '@/interfaces/breadcrumbs'

@Component
export default class AppBreadcrumbs extends Vue {
  @Prop({ type: Array, default: [] }) readonly breadcrumbs!: Breadcrumb[]
  @Prop(Boolean) readonly showBack!: boolean
  @Prop({ type: Boolean, default: false }) readonly directToList!: boolean
  @Prop({ type: String, default: '' }) readonly listPath!: string
  @Prop({ type: Boolean, default: false }) readonly isCustomBack!: boolean

  routeBack () {
    if (this.isCustomBack) {
      this.onBack()
      return
    }
    if (!this.directToList) {
      this.$router.go(-1)
    } else {
      this.$router.push({
        name: this.listPath
      })
    }
  }

  routeTo (to: any) {
    this.$router.push(to)
  }

  @Emit('back')
  onBack () {
    //
  }
}
